import { PERMISSION_KEYS } from "../constants";

export const CASCADE_BEHAVIORS = {
  STRICT_CASCADE: "STRICT_CASCADE",
  PARTIAL_CASCADE: "PARTIAL_CASCADE",
  NOTES_CASCADE: "NOTES_CASCADE",
  CHILD_SELECTS_PARENT: "CHILD_SELECTS_PARENT",
  LETTERS_RULE: "LETTERS_RULE",
  MERCURY_INBOX_FINANCIALS_RULES: "MERCURY_INBOX_FINANCIALS_RULES",
  THRESHOLD_HYSTERESIS: "THRESHOLD_HYSTERESIS",
};

export const RULE_TYPES = {
  MANAGE_RELATIONSHIPS: "MANAGE_RELATIONSHIPS",
  MANAGE_USERS: "MANAGE_USERS",
  MANAGE_WORKKARDS: "MANAGE_WORKKARDS",
  MANAGE_ACTIVITY: "MANAGE_ACTIVITY",
  MANAGE_NOTES: "MANAGE_NOTES",
  MANAGE_VIEWS: "MANAGE_VIEWS",
  MANAGE_DIARY: "MANAGE_DIARY",
  MANAGE_PARTIES: "MANAGE_PARTIES",

  CAN_ACCESS_MERCURY: "CAN_ACCESS_MERCURY",
  CAN_ACCESS_INBOX: "CAN_ACCESS_INBOX",
  CAN_ACCESS_FINANCIALS: "CAN_ACCESS_FINANCIALS",
  AUTHORIZED_STATES: "AUTHORIZED_STATES",
  MANAGE_LETTERS: "MANAGE_LETTERS",

  LOCK_WHEN_CHECKED: "LOCK_WHEN_CHECKED",
  DISABLE_WHEN_CHECKED: "DISABLE_WHEN_CHECKED",
  SPECIAL_CONDITION: "SPECIAL_CONDITION",
};

export const RULES = {

  [RULE_TYPES.MANAGE_RELATIONSHIPS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_RELATIONSHIPS,
    behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
  },

  [RULE_TYPES.MANAGE_USERS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_USERS,
    behavior: CASCADE_BEHAVIORS.THRESHOLD_HYSTERESIS,
    checkThreshold: 7,
  },

  [RULE_TYPES.MANAGE_WORKKARDS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_WORKKARDS,
    behavior: CASCADE_BEHAVIORS.THRESHOLD_HYSTERESIS,
    checkThreshold: 3,
  },

  [RULE_TYPES.MANAGE_ACTIVITY]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY,
    behavior: CASCADE_BEHAVIORS.THRESHOLD_HYSTERESIS,
    checkThreshold: 10,
  },

  [RULE_TYPES.MANAGE_NOTES]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES,
    behavior: CASCADE_BEHAVIORS.NOTES_CASCADE,
  },

  [RULE_TYPES.MANAGE_VIEWS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_REPORTS,
    behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
  },

  [RULE_TYPES.MANAGE_DIARY]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_TODOS,
    behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
  },

  [RULE_TYPES.MANAGE_PARTIES]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.STATIC_PARENTS.MANAGE_PARTIES,
    behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
  },



  [RULE_TYPES.CAN_ACCESS_MERCURY]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.DYNAMIC_PARENTS.MERCURY,
    behavior: CASCADE_BEHAVIORS.MERCURY_INBOX_FINANCIALS_RULES,
  },
 
  [RULE_TYPES.CAN_ACCESS_INBOX]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.DYNAMIC_PARENTS.INBOX,
    behavior: CASCADE_BEHAVIORS.MERCURY_INBOX_FINANCIALS_RULES,
  },
 
  [RULE_TYPES.CAN_ACCESS_FINANCIALS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.DYNAMIC_PARENTS.FINANCIALS,
    behavior: CASCADE_BEHAVIORS.MERCURY_INBOX_FINANCIALS_RULES,
  },

  [RULE_TYPES.AUTHORIZED_STATES]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.DYNAMIC_PARENTS.AUTHORIZED_STATES,
    behavior: CASCADE_BEHAVIORS.STRICT_CASCADE,
  },

  [RULE_TYPES.MANAGE_LETTERS]: {
    enabled: true,
    parentKey: PERMISSION_KEYS.DYNAMIC_PARENTS.LETTERS,
    behavior: CASCADE_BEHAVIORS.LETTERS_RULE,
  },



  [RULE_TYPES.LOCK_WHEN_CHECKED]: {
    enabled: true,
    targets: {
      [PERMISSION_KEYS.STATIC_PARENTS.MANAGE_RELATIONSHIPS]: [
        PERMISSION_KEYS.RELATIONSHIPS.DEASSOCIATE_B2B_RELATIONSHIP,
      ],
      [PERMISSION_KEYS.RELATIONSHIPS.MANAGE_CONTRACTS]: [
        PERMISSION_KEYS.RELATIONSHIPS.DEASSOCIATE_B2B_RELATIONSHIP,
      ],
      [PERMISSION_KEYS.STATIC_PARENTS.MANAGE_USERS]: [
        PERMISSION_KEYS.USERS.BLOCK_USER,
        PERMISSION_KEYS.USERS.EDIT_USER,
      ],
      [PERMISSION_KEYS.USERS.BLOCK_USER]: [PERMISSION_KEYS.USERS.EDIT_USER],
      [PERMISSION_KEYS.USERS.ADD_USER]: [PERMISSION_KEYS.USERS.EDIT_USER],
      [PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY]: [
        PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY,
        PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY,
        PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY,
        PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY,
      ],
      [PERMISSION_KEYS.ACTIVITY.CREATE_ACTIVITY]: [
        PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY,
        PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY,
      ],
      [PERMISSION_KEYS.ACTIVITY.RECEIVE_UNASSIGNED_ACTIVITIES]: [
        PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY,
        PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY,
      ],
      [PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES]: [
        PERMISSION_KEYS.NOTES.CLONE_NOTES,
      ],
      [PERMISSION_KEYS.WORKKARDS.CHANGE_WORKKARD_SPONSOR]: [
        { key: PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY, preserveOnRelease: true },
        { key: PERMISSION_KEYS.ACTIVITY.CHANGE_ACTIVITY_OWNER, preserveOnRelease: true },
      ],
    },
  },

  [RULE_TYPES.DISABLE_WHEN_CHECKED]: {
    enabled: true,
    targets: {},
  },

  [RULE_TYPES.SPECIAL_CONDITION]: {
    enabled: true,
    targets: {
      [PERMISSION_KEYS.NOTES.CLONE_NOTES]: {
        requiresAny: [
          PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PUBLIC,
          PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PRIVATE,
          PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PUBLIC,
          PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PRIVATE,
        ],
      },
    },
  },
};
